import { ConfigurationResponse } from '../types';

type TranslationFunction = (key: string) => string;

export const getBrandName = (
  configuration: ConfigurationResponse | undefined,
  t: TranslationFunction,
): string => (configuration?.data?.v2 ? t('branding.v2') : t('branding.default'));
